/**
 * @generated SignedSource<<2ff478bd0367b13fa8f1d873ed7878a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConnectedWalletMobileMenu_user$data = {
  readonly ethereumWalletAddress: {
    readonly address: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"NftAvatarCircle_address">;
  } | null;
  readonly profile: {
    readonly displayName: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectedWalletMenuContent_user">;
  readonly " $fragmentType": "ConnectedWalletMobileMenu_user";
};
export type ConnectedWalletMobileMenu_user$key = {
  readonly " $data"?: ConnectedWalletMobileMenu_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectedWalletMobileMenu_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConnectedWalletMobileMenu_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConnectedWalletMenuContent_user"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "ethereumWalletAddress",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NftAvatarCircle_address"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "c57de14c56a57e86d2e830aaa42b90ba";

export default node;
